<template>
  <div class="helpSupport">
    <div class="main-content">
      <h2>{{ $t('help_support')}}</h2>
      <section v-for="(item, idx) of dataArr" :key="idx">
        <h4 v-if="$i18n.locale === 'en'">{{item.questionEn}}</h4>
        <h4 v-if="$i18n.locale === 'ch'">{{item.questionCh }}</h4>
        <hr>
        <p v-if="$i18n.locale === 'en'">{{item.answerEn}}</p>
        <p v-if="$i18n.locale === 'ch'">{{item.answerCh}}</p>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  name: "helpSupport",
  data(){
    return {
      dataArr: [
        {
          // question: this.$t("how_much_membership"),
          questionEn: 'How much is a shopafm membership?',
          questionCh: '百家甄选的會員价格是多少钱？',
          // answer: this.$t("how_much_anser"),
          answerEn: 'Good question! Shopafm.com does not need a membership to shop. Click here to sign up and see your options.',
          answerCh: '好問題！ 百家甄选网购不需要會員即可購买下单。 單擊此處註冊並开始下单吧！',
        },
        {
          questionEn:'How are your prices determined? ',
          questionCh: '如何確定您的價格？',
          answerEn:" It's super simple! The price you see in the shopafm.com is the price you pay. Delivery is free for orders over $39. Smaller orders are welcome, but a $4.99 delivery fee will be added to help cover the costs of shopping and delivery.   shopafm prices will vary slightly from Asian Family Market in-store prices to help cover the costs of picking, packing and processing.",
          answerCh: '您在SHOPAFM.com上看到的價格就是您所支付的價格。訂單金額超過$ 39的會員可免費送貨。小於$ 39的訂單金額也是可以的，但需要支付$ 4.99的送貨費，以支付購物和送貨費用。 SHOPAFM.com的價格與線下門店內價格略有不同，以幫助支付提貨，包裝和加工費用。',
        },
        {
          questionEn:'Do you honor in-store sales?',
          questionCh: '網店和實體店價格活動一致嗎？',
          answerEn:"Shopfm offers special in-app pricing to help members save money (while also saving time). Though our weekly deals don’t always reflect in-store pricing, all Shipt sales are offered in one convenient place – our “What’s On Sale” category – for easy browsing.",
          answerCh: 'SHOPAFM.com提供特別的的線上特價活動，以幫助會員省錢（同時還節省時間）。儘管我們的每週特價並不總是和實體店內價格保持一致，但所有SHOPAFM.com的線上特價在一個便捷的位置（我們的“特價商品”類別）提供，以便於瀏覽。',
        },
        {
          questionEn:'Do you charge surge or busy pricing?',
          questionCh: '在高峰時間段收取額外的價格嗎？',
          answerEn: "Nope! Pricing is the same every time you use the app. We are committed to getting you the groceries you want, when you want them, regardless of how busy we are!",
          answerCh: '沒有！ 每次使用該網站時，其價格都是相同的。 無論我們有多忙，我們都致力於在您需要時為您提供所需的雜貨。',
        },
        {
          questionEn:'What should I do if the product I bought has expired?',
          questionCh: '如果我購買的產品已過期，我該怎麼辦？',
          answerEn: "In the rare case that you have purchased an expired product, please report it to the store’s Customer Service Center immediately so that we can promptly remove the product from the shelves. We give our sincerest apologies and we will happily refund or exchange your items.",
          answerCh: '在極少數情况下，您購買了過期產品，請立即向店鋪客戶服務中心報告，以便我們及時將產品下架。我們致以最誠摯的歉意，我們將很樂意為您退款或換貨。',
        }
      ]
    }
  },
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/helpSupport.less";
</style>



// WEBPACK FOOTER //
// src/view/helpSupport.vue